export const metadataParams = {
    manualUploadBehalfStatus: "on_behalf_of"
}

